export default __webpack_public_path__ + "static/Entenda0079-e4b4de9e6601569d12bb9a400c3b50ad.jpg";